/**
 * Store Header Functionalitiy
 */
class StoreHeader {
  constructor() {
    this.header = document.querySelector('.store-header');
    this.menuToggle = document.querySelector('[data-menu-drawer-toggle]');
    this.menuDrawer = document.getElementById('StoreMenuDrawer');
    this.menuClose = document.querySelector('[data-menu-drawer-close]');
    this.menuOverlay = document.querySelector('[data-menu-drawer-overlay]');
    
    if (this.menuToggle && this.menuDrawer) {
      this.initMenu();
    }

    this.initCartObserver();
  }

  initMenu() {
    this.menuToggle.addEventListener('click', () => this.openMenu());
    this.menuClose.addEventListener('click', () => this.closeMenu());
    this.menuOverlay.addEventListener('click', () => this.closeMenu());

    // Accessibility: Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.menuDrawer.classList.contains('is-open')) {
        this.closeMenu();
      }
    });

    // Accessibility: Focus trap
    this.menuDrawer.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        const focusableElements = this.menuDrawer.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
          }
        }
      }
    });
  }

  openMenu() {
    this.menuDrawer.classList.add('is-open');
    this.menuToggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('menu-open');
    
    // Focus close button when opening
    setTimeout(() => {
      this.menuClose.focus();
    }, 100);
  }

  closeMenu() {
    this.menuDrawer.classList.remove('is-open');
    this.menuToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
    
    // Return focus to toggle
    this.menuToggle.focus();
  }

  initCartObserver() {
    // Sync with existing cart count system if possible
    const cartCountEl = document.querySelector('[data-minicart-count]');
    if (!cartCountEl) return;

    const observer = new MutationObserver(() => {
      const count = cartCountEl.innerText;
      const cartToggle = document.querySelector('.store-header__cart-toggle');
      if (cartToggle) {
        cartToggle.setAttribute('aria-label', `Shopping cart, ${count} items`);
      }
    });

    observer.observe(cartCountEl, { childList: true, characterData: true, subtree: true });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new StoreHeader();
});

